// extracted by mini-css-extract-plugin
export default {"vision":"Vision_vision__BTd9T"};